import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';
import {MatSnackBar, MatTabGroup} from '@angular/material';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {EmailtemplateListenerService} from '../emailtemplate-listener.service';
import {TourStep} from 'ngx-guided-tour/lib/guided-tour.constants';
import {Orientation} from 'ngx-guided-tour';
import {AccountInfoService} from '../user/account-info.service';
@Component({
    selector: 'app-emailtemplatebuilder',
    templateUrl: './emailtemplatebuilder.component.html',
    styleUrls: ['./emailtemplatebuilder.component.scss']
})
export class EmailtemplatebuilderComponent implements OnInit {

    @Input() templateName: string;
    @Input() selectedVersion: string;
    @Input() templateDescription: string;
    @Input() templateCategory: string;
    @Input() subject: string;
    @Input() templateData: any;
    @Input() dataPreLoaded = false;
    body: any;
    templateID: any;

    @Input() ignoreRouteParams = false;
    @Input() isEditTemplate: boolean;
    @Input() isEditDisabled = false;

    createTemplatePayload = {
        partner: '',
        account: '',
        name: '',
        version: '',
        category: '',
        description: '',
        subject: '',
        body: '',
        inputType: ''
    };

    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');

    loading = false;
    @Input() removeMatCardPadding = true;

    @ViewChild('name', {static: false}) public MyForm: NgModel;
    @ViewChild('version', {static: false}) public MyForm1: NgModel;
    @ViewChild('category', {static: false}) public MyForm2: NgModel;

    @ViewChild(MatTabGroup) tabref: MatTabGroup;

    constructor(public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                private confPost: ConfService,
                private _service: ConnecttocrudService,
                private route: ActivatedRoute,
                public emailTemplatesListenerInstance: EmailtemplateListenerService,
                public router: Router) { }

    ngOnInit() {

        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        this.createTemplatePayload.partner = this.partner;
        this.createTemplatePayload.account = this.account;

        if (!this.ignoreRouteParams) {
            this.route.queryParams
                .subscribe(params => {
                    if (params) {
                        if (params.template && params.template !== '') {
                            this.isEditTemplate = true;
                            this.confPost.getData('campaign', 'campaign', 'v1', 'emailTemplate', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&name=' + params.template).subscribe(response => {
                                this.createTemplatePayload.inputType = response[0]['inputType'];
                                this.selectedVersion = response[0]['version'];
                                this.templateDescription = response[0]['description'];
                                this.templateCategory = response[0]['category'];
                                this.templateName = response[0]['name'];
                                this.templateID = response[0]['id'];
                                if (response[0]['inputType'] !== 'emailDesigner' || response[0]['inputType'] !== 'advancedBuilderText') {
                                    this.body = response[0]['body'];
                                }

                                if (this.createTemplatePayload.inputType === 'simpleText' || this.createTemplatePayload.inputType === 'freeText') {
                                    this.tabref.selectedIndex = 0;
                                } else if (this.createTemplatePayload.inputType === 'htmlContent') {
                                    this.tabref.selectedIndex = 1;
                                } else if (this.createTemplatePayload.inputType === 'emailDesigner' || this.createTemplatePayload.inputType === 'advancedBuilderText') {
                                    this.tabref.selectedIndex = 2;
                                }
                            });
                        } else {
                            this.isEditTemplate = false;
                        }
                    } else {
                        this.isEditTemplate = false;
                    }

                });
        }

        if (this.dataPreLoaded) {
            if (this.templateData) {
                // this.confPost.getData('campaign', 'campaign', 'v1', 'emailTemplate', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&name=' + this.templateData['name']).subscribe(response => {
                    this.createTemplatePayload.inputType = this.templateData['inputType'];
                    this.selectedVersion = this.templateData['version'];
                    this.templateDescription = this.templateData['description'];
                    this.templateCategory = this.templateData['category'];
                    this.templateName = this.templateData['name'];
                    this.templateID = this.templateData['id'];
                    if (this.templateData['inputType'] !== 'emailDesigner' || this.templateData['inputType'] !== 'advancedBuilderText') {
                        this.body = this.templateData['body'];
                    }

                    if (this.createTemplatePayload.inputType === 'simpleText' || this.createTemplatePayload.inputType === 'freeText') {
                        this.tabref.selectedIndex = 0;
                    } else if (this.createTemplatePayload.inputType === 'htmlContent') {
                        this.tabref.selectedIndex = 1;
                    } else if (this.createTemplatePayload.inputType === 'emailDesigner' || this.createTemplatePayload.inputType === 'advancedBuilderText') {
                        this.tabref.selectedIndex = 2;
                    }
            }
        }

        // console.log(this.isEditTemplate);
        if (!this.isEditTemplate) {
            this.createTemplatePayload.inputType = 'simpleText';
            this.selectedVersion = '';
            this.templateDescription = '';
            this.templateCategory = '';
            this.templateName = '';
        } else {
        }

        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        }
        bindEvent(window, 'message', function (e) {
            this.results = e.data;
            localStorage.setItem('htmlContent', e.data);
            this.body = e.data;
        });

        if (this.platform.properties.length > 0) {
            this.platform.setGuideTourSteps(this.getEmailTemplateBuilderTourSteps());
        }

        // console.log(this.myInputMsg);

    }


  refreshSubjectAndBody(selectedIndex) {
    if (selectedIndex === 0) {
      this.createTemplatePayload.inputType = 'simpleText';
    } else if (selectedIndex === 1) {
      this.createTemplatePayload.inputType = 'htmlContent';
    } else if (selectedIndex === 2) {
      this.createTemplatePayload.inputType = 'emailDesigner';
    }
    // this.subject = '';
    // this.body = '';
  }

    saveDescription(value) {
        this.body = value;
    }

    getEmailTemplateBuilderTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_INTRO_TITLE'),
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_INTRO_CONTENT')
        });

        steps.push({
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_NAME_TITLE'),
            selector: '.tour-template-builder-template-name',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_VERSION_TITLE'),
            selector: '.tour-template-builder-template-version',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_DESCRIPTION_TITLE'),
            selector: '.tour-template-builder-template-description',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_DESCRIPTION_TITLE'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_CATEGORY_TITLE'),
            selector: '.tour-template-builder-template-category',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_TEMPLATE_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_SIMPLE_TEXT_TAB_TITLE'),
            selector: '.tour-template-builder-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1)',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_SIMPLE_TEXT_TAB_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_HTML_CONTENT_TAB_TITLE'),
            selector: '.tour-template-builder-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2)',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_HTML_CONTENT_TAB_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_EMAIL_DESIGNER_TAB_TITLE'),
            selector: '.tour-template-builder-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_EMAIL_DESIGNER_TAB_CONTENT'),
            orientation: Orientation.Bottom
        });
        if (this.isEditTemplate) {
            steps.push({
                title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_EDIT_TEMPLATE_TITLE'),
                selector: '.tour-template-builder-edit-template ',
                content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_EDIT_TEMPLATE_CONTENT'),
                orientation: Orientation.Bottom
            });
        } else {
            steps.push({
                title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_CREATE_TEMPLATE_TITLE'),
                selector: '.tour-template-builder-create-template',
                content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_CREATE_TEMPLATE_CONTENT'),
                orientation: Orientation.Bottom
            });
        }

        return steps;

    }

    createTemplate() {
        this.loading = true;
        if ((this.createTemplatePayload.inputType === 'simpleText' || this.createTemplatePayload.inputType === 'htmlContent') &&  this.MyForm.valid && this.MyForm1.valid && this.MyForm2.valid) {
            this.createTemplatePayload.name = this.templateName;
            this.createTemplatePayload.version = this.selectedVersion;
            this.createTemplatePayload.description = this.templateDescription;
            this.createTemplatePayload.category = this.templateCategory;
            this.createTemplatePayload.subject = this.subject;
            this.createTemplatePayload.body = this.body;

            if (!this.isEditTemplate) {
                   this._service.addEmailTemplate(this.createTemplatePayload, 'v1', 'campaign', 'campaign', 'emailTemplate').subscribe(data => {
                    this.platform.openSnackBar('Template created successfully.', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading = false;
                    this.router.navigateByUrl('/email-templates');
                }, error => {
                    this.platform.openSnackBar('Cannot create template. Please try again', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading = false;
                });
            } else if (this.isEditTemplate) {
                // tslint:disable-next-line:max-line-length
                this._service.updateEmailTemplate(this.createTemplatePayload, 'v1', 'campaign', 'campaign', 'emailTemplate', this.templateID).subscribe(data => {
                    this.platform.openSnackBar('Template updated successfully.', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading = false;
                    this.router.navigateByUrl('/email-templates');
                }, error => {
                    this.platform.openSnackBar('Cannot update template. Please try again', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading = false;
                });
            }

            // tslint:disable-next-line:max-line-length
        } else if (this.createTemplatePayload.inputType === 'emailDesigner' &&  this.MyForm.valid && this.MyForm1.valid && this.MyForm2.valid) {
            this.createTemplatePayload.name = this.templateName;
            this.createTemplatePayload.version = this.selectedVersion;
            this.createTemplatePayload.description = this.templateDescription;
            this.createTemplatePayload.category = this.templateCategory;
            this.createTemplatePayload.subject = this.subject;
            let body = localStorage.getItem('htmlContent');
            body = JSON.parse(body);
            localStorage.removeItem('htmlContent');
            let html = body['html'];
            const editorCss = body['editorCss'];
            const narrowJumbotron = body['narrow-jumbotron'];

            // editor css
            const payload = {
                'fileName' : localStorage.getItem('partner') + '-' + localStorage.getItem('account') + '-' + this.templateName + '-' + this.selectedVersion + '-editor.css',
                'fileContent' : editorCss,
                'bucketLocation' : 'emailTemplate/css'
            };

            this._service.uploadTextToS3AndGetFileURL(localStorage.getItem('partner'), localStorage.getItem('account'), payload).subscribe(response => {
                html  = html.replace('../../css/editor.css', response['s3URL']);
                // narrow-jumbotron css
                const payload1 = {
                    'fileName' : localStorage.getItem('partner') + '-' + localStorage.getItem('account') + '-' + this.templateName + '-' + this.selectedVersion + '-narrow-jumbotron.css',
                    'fileContent' : narrowJumbotron,
                    'bucketLocation' : 'emailTemplate/css'
                };

                this._service.uploadTextToS3AndGetFileURL(localStorage.getItem('partner'), localStorage.getItem('account'), payload1).subscribe(response1 => {

                    html  = html.replace('narrow-jumbotron.css', response1['s3URL']);
                    this.createTemplatePayload.body = html;
                    if (!this.isEditTemplate) {
                        this._service.addEmailTemplate(this.createTemplatePayload, 'v1', 'campaign', 'campaign', 'emailTemplate').subscribe(data => {
                            this.platform.openSnackBar('Template created successfully.', 'Success', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.loading = false;
                        }, error => {
                            this.platform.openSnackBar('Cannot create template. Please try again', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.loading = false;
                        });
                    } else if (this.isEditTemplate) {
                        this._service.updateEmailTemplate(this.createTemplatePayload, 'v1', 'campaign', 'campaign', 'emailTemplate', this.templateID).subscribe(data => {
                            this.platform.openSnackBar('Template updated successfully.', 'Success', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.loading = false;
                        }, error => {
                            this.platform.openSnackBar('Cannot update template. Please try again', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.loading = false;
                        });
                    }
                }, error => {
                    this.platform.openSnackBar('Server Error. Please try again later', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading = false;
                });
            }, error => {
                this.platform.openSnackBar('Server Error. Please try again later', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
            });


        } else {
            this.platform.openSnackBar('Please make sure you provide template name, version and category', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.loading = false;
        }
    }

    createMarginRight() {
        document.getElementById('view:email_template_builder').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:email_template_builder').style.marginRight = '0px';
    }
}
